/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { createAction } from '../../../../utils/redux-utils';
import { CashBoxStateHistoryDto, CashBoxStateHistoryQueryParams } from '../../../api/cashBoxes/cashBoxesClient.typings';
import { Notification } from '../../../../utils/utils';
import { PeriodQueryParams } from '../../../api/apiCommon.typings';

export enum CashBoxStateTabActionType {
    EXIT_CASHBOX_STATE_TAB = 'CashBoxStateTab/ exit tab',
    FETCH_CASHBOX_STATE_HISTORY = 'CashBoxStateTab/ fetch state history start',
    FETCH_CASHBOX_STATE_HISTORY_SUCCESS = 'CashBoxStateTab/ fetch state history success',
    FETCH_CASHBOX_STATE_HISTORY_ERROR = 'CashBoxStateTab/ fetch state history error',
    DOWNLOAD_STATE_HISTORY = 'CashBoxStateTab/ download state history as excel start',
    DOWNLOAD_STATE_HISTORY_SUCCESS = 'CashBoxStateTab/ download state history as excel success',
    DOWNLOAD_STATE_HISTORY_ERROR = 'CashBoxStateTab/ download state history as excel error',
}

export const exitCashBoxStateTabAction = () => createAction(CashBoxStateTabActionType.EXIT_CASHBOX_STATE_TAB);

export const fetchCashBoxStateHistoryAction = (params: CashBoxStateHistoryQueryParams) =>
    createAction(CashBoxStateTabActionType.FETCH_CASHBOX_STATE_HISTORY, params);

export const fetchCashBoxStateHistorySuccessAction = (payload: CashBoxStateHistoryDto) =>
    createAction(CashBoxStateTabActionType.FETCH_CASHBOX_STATE_HISTORY_SUCCESS, payload);

export const fetchCashBoxStateHistoryErrorAction = (notification: Notification) =>
    createAction(CashBoxStateTabActionType.FETCH_CASHBOX_STATE_HISTORY_ERROR, { notification });

export const downloadStateHistoryAction = (params: PeriodQueryParams) =>
    createAction(CashBoxStateTabActionType.DOWNLOAD_STATE_HISTORY, params);

export const downloadStateHistorySuccessAction = () =>
    createAction(CashBoxStateTabActionType.DOWNLOAD_STATE_HISTORY_SUCCESS);

export const downloadStateHistoryErrorAction = (notification: Notification) =>
    createAction(CashBoxStateTabActionType.DOWNLOAD_STATE_HISTORY_ERROR, { notification });

export type CashBoxStateTabAction =
    | ReturnType<typeof exitCashBoxStateTabAction>
    | ReturnType<typeof fetchCashBoxStateHistoryAction>
    | ReturnType<typeof fetchCashBoxStateHistorySuccessAction>
    | ReturnType<typeof fetchCashBoxStateHistoryErrorAction>
    | ReturnType<typeof downloadStateHistoryAction>
    | ReturnType<typeof downloadStateHistorySuccessAction>
    | ReturnType<typeof downloadStateHistoryErrorAction>;
